import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/team/[slug]/page-client.tsx");
